export default ({ children, homepage = false, header }) => {
    return (
        <div className="relative bg-black">
            <div className="absolute inset-0">
                <picture>
                    <source
                        srcSet="/assets/webp/personal-training-uden-schijndel.webp"
                        width="1440"
                        height="960"
                        type="image/webp"
                        alt="Transformaties personal training Uden en Schijndel"
                        className="w-full h-full object-cover xs:max-h-screen sm:max-h-screen"
                    />
                    <source
                        srcSet="/assets/personal-training-uden-schijndel.png"
                        width="1440"
                        height="960"
                        type="image/jpeg"
                        alt="Transformaties personal training Uden en Schijndel"
                        className="w-full h-full object-cover xs:max-h-screen sm:max-h-screen"
                    />
                    <img
                        src="/assets/personal-training-uden-schijndel.png"
                        width="1440"
                        height="960"
                        alt="Transformaties personal training Uden en Schijndel"
                        className="w-full h-full object-cover xs:max-h-screen sm:max-h-screen"
                    />
                </picture>
                <div
                    className="absolute inset-0 bg-gray-500 mix-blend-multiply"
                    aria-hidden="true"
                />
            </div>
            <div className="relative max-w-7xl text-center mx-auto py-16 px-4 sm:px-6 lg:px-8">
                {homepage && (
                    <span className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-2xl sm:text-2xl md:text-6xl lg:text-6xl">
                        Jouw transformatie binnen 12 weken!{" "}
                    </span>
                )}

                <h1 className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-xxl">
                    <span className="text-we-are-yellow">We </span>
                    <span className="text-we-are-purple">Are</span>
                </h1>
                {header && (
                    <span className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-2xl sm:text-2xl md:text-6xl lg:text-6xl">
                        {header}
                    </span>
                )}
                <div className="flex-1 mt-4 relative px-6 pb-8 md:px-8">
                    {children}
                </div>
            </div>
        </div>
    );
};
